import { Component, OnInit } from "@angular/core";
import { ComponentBase } from "../../models/ComponentBase";
import { Router } from "@angular/router";
import {
    faChevronCircleLeft,
    IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { OccurenceTypeService } from "../../services/occurence-type.service";
import { OccurenceType } from "../../WebApiClient";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "../../services/toast.service";

@Component({
    selector: "app-occurence-types",
    templateUrl: "./occurence-types.component.html",
    styleUrls: [
        "./occurence-types.component.scss",
        "../../style/sidebarLayout.scss",
        "../../style/form-table.scss",
    ],
    standalone: false,
})
export class OccurenceTypesComponent extends ComponentBase implements OnInit {
    faBack: IconDefinition = faChevronCircleLeft;

    showEditor: boolean = false;
    showDeleteButton: boolean = false;
    occurenceTypeSelected: OccurenceType | undefined;

    occurenceTypeForm: FormGroup = new FormGroup({
        name: new FormControl("", Validators.required),
    });

    public occurenceTypeList: OccurenceType[] | undefined;

    cardHeader: string = "Add Type";

    constructor(
        private readonly router: Router,
        private readonly occurenceTypeService: OccurenceTypeService,
        private readonly toastService: ToastService
    ) {
        super();

        let response = this.occurenceTypeService.occurenceTypes.subscribe(
            (r) => {
                if (r.loading) {
                    return;
                }
                this.occurenceTypeList = r.occurenceTypes;
            }
        );
        this.subscriptions.push(response);
    }

    ngOnInit(): void {}

    back() {
        this.router.navigate(["/projects"]);
    }

    add() {
        this.occurenceTypeSelected = undefined;
        this.showEditor = true;

        this.cardHeader = "Add Type";
    }

    edit(occcurenceType: OccurenceType) {
        this.occurenceTypeSelected = occcurenceType;
        this.showEditor = true;

        this.nameControl.setValue(occcurenceType.name);

        this.cardHeader = "Edit Type";
    }

    cancel() {
        this.showEditor = false;
        this.occurenceTypeSelected = undefined;
    }
    async delete() {
        if (!this.occurenceTypeSelected || !this.occurenceTypeSelected.id) {
            return;
        }

        var isSure = confirm("Are you sure you want to delete the Occurence Type?");
        if (!isSure) {
            return;
        }

        await this.occurenceTypeService
            .deleteOccurenceType(this.occurenceTypeSelected.id)
            .then(() => {
                this.toastService.add(
                    "Deleted success",
                    "Occurence Type has been deleted",
                    "success"
                );

                this.cancel();
            })
            .catch(() => {
                this.toastService.add(
                    "Delete failed",
                    "Something went wrong. Please try again.",
                    "danger"
                );
            });
    }

    save() {
        if (this.occurenceTypeForm.invalid) {
            return;
        }

        if (this.occurenceTypeSelected) {
            this.occurenceTypeService
                .updateOccurenceType(
                    this.occurenceTypeSelected.id,
                    this.occurenceTypeForm.value.name
                )
                .then(() => {
                    this.toastService.add(
                        "Saved success",
                        "Type has been updated",
                        "success"
                    );

                    this.cancel();
                });
        } else {
            this.occurenceTypeService
                .addOccurenceType(this.occurenceTypeForm.value.name)
                .then(() => {
                    this.toastService.add(
                        "Saved success",
                        "Type has been created",
                        "success"
                    );

                    this.cancel();
                });
        }
    }

    get nameControl(): FormControl {
        return this.occurenceTypeForm.get("name") as FormControl;
    }
}
